<script setup lang="ts">
import type { GroupData } from '~/types/groups'

const props = defineProps<{
  group?: GroupData
}>()

const { t, locale } = useI18n()

const formattedMemberCount = computed(() => {
  const count = props.group?.members_count ?? 0
  const maximumFractionDigits = count >= 100000 ? 0 : 1

  return new Intl.NumberFormat(locale.value || 'en', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits,
    roundingMode: 'floor'
  }).format(count)
})
</script>

<template>
  <div class="tw-flex tw-items-center tw-gap-2">
    <p class="tw-black/80">
      <template v-if="props.group">
        <span class="tw-font-semibold">{{ formattedMemberCount }}</span>
        <span>{{ t('x-members', props.group.members_count) }}</span>
      </template>

      <template v-else>-</template>
    </p>
  </div>
</template>
